export default "__VITE_ASSET__DtmXzpzC__"